import { createRouter, createWebHistory } from 'vue-router'
import { routes as routes } from '../app/index'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router
